import { render, staticRenderFns } from "./UnBalanced.vue?vue&type=template&id=20e2221d&scoped=true"
import script from "./UnBalanced.vue?vue&type=script&lang=js"
export * from "./UnBalanced.vue?vue&type=script&lang=js"
import style0 from "./UnBalanced.vue?vue&type=style&index=0&id=20e2221d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2221d",
  null
  
)

export default component.exports